import {AppName, NavigationTab} from "./navigation";

const matchesLink = (link: string, pathname: string) =>
  link === '/' || pathname === link || pathname.startsWith(link + '/')

// The most specific (longest) matching link wins, so a tab linking to '/' acts as the fallback for its app.
export const findActiveNavigationTab = (tabs: NavigationTab[], app: AppName, pathname: string): NavigationTab | undefined =>
  tabs
    .filter(tab => tab.app === app && matchesLink(tab.link, pathname))
    .sort((a, b) => b.link.length - a.link.length)[0]
